import { alertSlice } from './alert';

export const { addAlert, removeAlert, timestampAlert, resetAlertStore } = alertSlice.actions;
export const { reducer: alertReducer } = alertSlice;

export type { AlertAction, AlertState } from './types';
